// @ts-nocheck

const heapTrackEventType = (
  eventName,
  eventType = '',
  restEventValues = {}
) => {
  if (window.lcTracking) {
    window.lcTracking.trackCustomEvent({
      eventName,
      eventType,
      ...restEventValues
    });
  }
};

const heapTrackEvent = (eventName, restEventValues = {}) => {
  if (window.lcTracking) {
    window.lcTracking.trackCustomEvent({
      eventName,
      ...restEventValues
    });
  }
};

export { heapTrackEvent, heapTrackEventType };

